export class SpeechBubble {

    /**
     * 
     * @param {Boolean} visible 
     */
    constructor(visible) {
        this.visible = visible;

        // Instantiate the main walkthrough HTMLParagraphElement
        this.element = document.createElement("p");
        this.element.classList.add("walkthrough-speech-bubble");
        if (!visible) {
            this.element.classList.add("hidden");
        }

        // Setup callback to fade in additional text after speech bubble pop in is finished.
        // Workaround for drop shadow flicker when animations on multiple nested elements coincide.
        this.element.addEventListener("animationend", event => {
            if (event.animationName === "pop-in") {
                this.fadeInSpans();
            }
        });
    }

    setText(text) {
        this.element.textContent = text;
    }

    setInnerHTML(html) {
        this.element.innerHTML = html;
    }

    setChildren(element){
        while(this.element.firstChild) {
            this.element.removeChild(this.element.firstChild);
        }
        this.element.appendChild(element)
    }

    popIn() {
        this.visible = true;
        this.element.classList.remove("hidden");
        this.element.classList.remove("pop-out");
        this.element.classList.add("pop-in");
    }

    popOut() {
        this.visible = false;

        // Fade out the bubble itself
        this.element.classList.remove("pop-in");
        this.element.classList.add("pop-out");

        // Clean up the fade-in class we added
        this.element.querySelectorAll("span").forEach(element => {
            element.classList.remove("fade-in");
        });
    }

    /**
     * Trigger all spans to fade in
     */
    fadeInSpans() {
        this.element.querySelectorAll("span").forEach(element => {
            element.classList.add("fade-in");
        });
    }

    isVisible() {
        return this.visible;
    }
}